import { useEffect } from "react";
import { useTaskLists } from "@/data/taskHooks";
import { useUi } from "@/store/ui";
import { TaskListView } from "./TaskListView";
import { TasksDashboard } from "./TasksDashboard";

/** Main Tasks application surface, independent from Notes tabs. */
export function TasksApp() {
  const lists = useTaskLists();
  const active = useUi((state) => state.activeTaskView);

  useEffect(() => {
    if (active !== "overview" && lists.length > 0 && !lists.some((list) => list.listId === active)) {
      useUi.getState().openTaskView("overview");
    }
  }, [active, lists]);

  return active === "overview" ? <TasksDashboard /> : <TaskListView listId={active} />;
}
